import script from "./VisibleTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./VisibleTrigger.vue?vue&type=script&setup=true&lang=js"

import "./VisibleTrigger.vue?vue&type=style&index=0&id=0fa1b97f&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa1b97f"]])

export default __exports__